import React from "react";

export default function Contact() {
  return (
    <div style={styles.container}>
      <div style={styles.grid}>

        {/* LEFT — CONTACT */}
        <div>
          <h1>Engage with FentaSafe</h1>
          <div style={styles.tagline}>
            FentaSafe Technologies, Inc. • Florida Corporation • Patent Pending
          </div>

          <p style={styles.subtitle}>
            Partner with FentaSafe for pilot evaluations, research collaborations,
            and public safety innovation initiatives.
          </p>

          <div style={styles.banner}>
            Patent Pending • Florida Corporation • SBIR/STTR Opportunity Ready • SVPP Aligned • Research Collaboration Ready
          </div>

          <div style={styles.card}>

            <div style={styles.contactItem}>
              <strong>Founder & President</strong><br />
              <a href="mailto:premarajan@fentasafe.org" style={styles.link}>
                premarajan@fentasafe.org
              </a>
              {" "}|{" "}
              <a href="mailto:founder@fentasafe.org" style={styles.link}>
                founder@fentasafe.org
              </a>
            </div>

            <div style={styles.contactItem}>
              <strong>General Information</strong><br />
              <a href="mailto:info@fentasafe.org" style={styles.link}>
                info@fentasafe.org
              </a>
            </div>

            <div style={styles.contactItem}>
              <strong>Partnerships & Pilot Programs</strong><br />
              <a href="mailto:contact@fentasafe.org" style={styles.link}>
                contact@fentasafe.org
              </a>
            </div>

            <div style={styles.contactItem}>
              <strong>Research & Grant Collaborations</strong><br />
              <a href="mailto:grants@fentasafe.org" style={styles.link}>
                grants@fentasafe.org
              </a>
            </div>

            <div style={styles.contactItem}>
              <strong>Phone / WhatsApp</strong><br />
              <a href="tel:+919176540888" style={styles.link}>
                +91 91765 40888
              </a>
              <span style={styles.note}> (India operations)</span>
            </div>

            <div style={styles.contactItem}>
              <strong>Operating Presence</strong><br />
              United States • India
            </div>

            <div style={styles.contactItem}>
              <strong>Corporate Entity</strong><br />
              FentaSafe Technologies, Inc.<br />
              Florida Corporation<br />
              Document No: P26000033569<br />
              State of Florida, USA<br />
              <a
                href="https://search.sunbiz.org"
                target="_blank"
                rel="noreferrer"
                style={styles.link}
              >
                Verify at sunbiz.org →
              </a>
            </div>

            <div style={styles.contactItem}>
              <strong>Patent Status</strong><br />
              Patent Pending<br />
              Indian Patent Application No. 202641022911<br />
              Filed: 26-Feb-2026
            </div>

            <div style={styles.contactItem}>
              <strong>LinkedIn</strong><br />
              <a
                href="https://www.linkedin.com/in/premarajan-abel-13a15349/"
                target="_blank"
                rel="noreferrer"
                style={styles.link}
              >
                linkedin.com/in/premarajan-abel-13a15349
              </a>
            </div>

            <div style={styles.contactItem}>
              <strong>Website</strong><br />
              <a
                href="https://www.fentasafe.org"
                target="_blank"
                rel="noreferrer"
                style={styles.link}
              >
                www.fentasafe.org
              </a>
            </div>

            <div style={styles.contactItem}>
              <strong>Availability</strong><br />
              Pilot Programs • Research Studies • Public Safety Evaluations • SVPP-Aligned School District Discussions
            </div>

          </div>

          <button
            style={styles.button}
            onClick={() =>
              (window.location.href =
                "mailto:contact@fentasafe.org?subject=FentaSafe Pilot Discussion")
            }
          >
            Discuss Pilot Opportunities
          </button>

          <a
            href="mailto:info@fentasafe.org"
            style={styles.secondaryButton}
          >
            Email FentaSafe →
          </a>

          <p style={styles.footerText}>
            Interactive demonstration available.<br /><br />
            FentaSafe Technologies, Inc. is developing AI-powered environmental
            intelligence technologies for situational awareness, risk assessment,
            early warning, and emergency alerting.<br /><br />
            Pilot evaluations, research collaborations, and public safety innovation
            discussions are welcome.
          </p>

        </div>

        {/* RIGHT — ENGAGEMENT PATHS */}
        <div style={styles.rightCol}>

          <h2>Who We Work With</h2>
          <ul>
            <li>K-12 Schools & School Districts</li>
            <li>Law Enforcement Agencies</li>
            <li>Public safety agencies</li>
            <li>Educational institutions</li>
            <li>Smart city initiatives</li>
            <li>Healthcare & community safety programs</li>
            <li>Research and innovation partners</li>
          </ul>

          <h3 style={styles.sectionTitle}>Pilot Engagement Includes</h3>
          <ul>
            <li>Scenario configuration</li>
            <li>Site-specific signal modeling</li>
            <li>Operator workflow alignment</li>
            <li>Governance & policy review</li>
          </ul>

          <h3 style={styles.sectionTitle}>Pilot Readiness</h3>
          <ul>
            <li>Demonstration Platform Available</li>
            <li>Research Collaboration Ready</li>
            <li>Human-Supervised AI Design</li>
            <li>Privacy-Preserving Architecture</li>
            <li>SVPP Grant-Eligible Deployment</li>
          </ul>

          <h3 style={styles.sectionTitle}>Founder</h3>
          <div style={styles.founderBlock}>
            <div style={styles.founderName}>Premarajan Abel</div>
            <div style={styles.founderTitle}>
              Founder, President & Lead Architect<br />
              FentaSafe Technologies, Inc.
            </div>
            <div style={styles.founderExpertise}>
              AI-Assisted Public Safety Intelligence<br />
              Automation • Digital Transformation • Enterprise Innovation
            </div>
            <p style={styles.founderText}>
              27+ years in enterprise technology, automation, AI-assisted systems,
              digital transformation, and public safety innovation across India and the USA.
            </p>
            <p style={styles.founderText}>
              Indian Patent Application No. 202641022911 (Pending).<br />
              Research collaboration in progress with ICMR-NINE.
            </p>
          </div>

          <div style={styles.footerNote}>
            Research collaboration • Pilot readiness • Public safety innovation
          </div>

          <h3 style={styles.sectionTitle}>Federal Funding Alignment</h3>
          <ul style={styles.fundingList}>
            <li><strong style={{color:"#93c5fd"}}>NSF SBIR/STTR Programs</strong> — R&D funding</li>
            <li><strong style={{color:"#93c5fd"}}>COPS SVPP</strong> — school deployment funding (up to $500K/district)</li>
            <li>School Safety Technology Initiatives</li>
            <li>Public Safety Innovation Programs</li>
            <li>Research Collaborations</li>
            <li>Smart Campus Safety Programs</li>
          </ul>

          <h3 style={styles.sectionTitle}>School Safety Focus</h3>
          <ul style={styles.fundingList}>
            <li>Situational Awareness</li>
            <li>Environmental Threat Detection</li>
            <li>Early Warning & Alerting</li>
            <li>Emergency Response Integration</li>
            <li>School Safety Technology Pilots</li>
          </ul>

        </div>

      </div>
    </div>
  );
}

const styles = {
  banner: {
    background: "#1e3a8a",
    padding: "10px 16px",
    borderRadius: "8px",
    marginBottom: "20px",
    color: "#dbeafe",
    fontWeight: "600",
  },

  tagline: {
    color: "#93c5fd",
    marginBottom: "10px",
    fontWeight: "600",
  },

  container: {
    minHeight: "calc(100vh - 80px)",
    background: "#0f172a",
    color: "#fff",
    padding: "40px 24px",
  },

  grid: {
    maxWidth: 1100,
    margin: "0 auto",
    display: "grid",
    gridTemplateColumns: "1.1fr 0.9fr",
    gap: 40,
    alignItems: "start",
  },

  subtitle: {
    opacity: 0.85,
    marginBottom: 18,
  },

  card: {
    background: "#020617",
    border: "1px solid #1e293b",
    borderRadius: 12,
    padding: 20,
    lineHeight: 1.6,
    marginBottom: 20,
  },

  rightCol: {
    background: "#020617",
    border: "1px solid #1e293b",
    borderRadius: 14,
    padding: 24,
    height: "fit-content",
  },

  button: {
    padding: "12px 24px",
    background: "#2563eb",
    border: "none",
    borderRadius: 6,
    color: "#fff",
    cursor: "pointer",
    fontSize: 15,
  },

  secondaryButton: {
    display: "inline-block",
    marginTop: "12px",
    marginLeft: "12px",
    padding: "12px 20px",
    borderRadius: "8px",
    background: "#f59e0b",
    color: "#ffffff",
    textDecoration: "none",
    fontWeight: "600",
    border: "1px solid #fbbf24",
    boxShadow: "0 0 12px rgba(245,158,11,0.25)",
  },

  contactItem: {
    marginBottom: "18px",
    lineHeight: "1.7",
  },

  link: {
    color: "#60a5fa",
    textDecoration: "none",
  },

  note: {
    color: "#64748b",
    fontSize: "0.85rem",
  },

  sectionTitle: {
    marginTop: "20px",
    marginBottom: "10px",
    color: "#ffffff",
  },

  footerText: {
    marginTop: "15px",
    lineHeight: "1.7",
    color: "#cbd5e1",
  },

  footerNote: {
    marginTop: 20,
    fontSize: 13,
    opacity: 0.6,
    fontStyle: "italic",
  },

  founderBlock: {
    marginTop: "10px",
  },

  founderName: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#ffffff",
    marginBottom: "4px",
  },

  founderTitle: {
    fontSize: "14px",
    color: "#93c5fd",
    marginBottom: "10px",
  },

  founderExpertise: {
    fontSize: "13px",
    lineHeight: "1.7",
    color: "#d1d5db",
    marginBottom: "12px",
  },

  founderText: {
    fontSize: "14px",
    lineHeight: "1.8",
    color: "#cbd5e1",
    marginBottom: 8,
  },

  fundingList: {
    lineHeight: "1.8",
    paddingLeft: "20px",
  },
};
